import { render, staticRenderFns } from "./service-management.vue?vue&type=template&id=10911e77&scoped=true&"
import script from "./service-management.vue?vue&type=script&lang=js&"
export * from "./service-management.vue?vue&type=script&lang=js&"
import style0 from "./service-management.vue?vue&type=style&index=0&id=10911e77&lang=less&scoped=true&"
import style1 from "./service-management.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10911e77",
  null
  
)

export default component.exports